import React from "react"
import lottery from "../images/lottery.jpg"
import minimumwidth from "../images/minimumwidth.png"
import zeroinit from "../images/zeroinit.png"
import constructive from "../images/constructive.jpg"
import Container from "react-bootstrap/Container";
import Card from 'react-bootstrap/Card'

const Interest = (props) => (
    <div className="col-sm-12 col-lg-6" style={{
        display: "flex", flexDirection: "column",
        justifyContent: "space-between"
    }}>
        {props.children}

    </div>
)


const InterestBody = (props) => (
    <div>
        <Card.Title as="h4" className="card-title-color">{props.title}</Card.Title>
        <Card>
            <Card.Body>
                <Card.Text as="div" className="text-justify">{props.children}</Card.Text>
            </Card.Body>

        </Card>
    </div>
)

const InterestLinkSection = (props) => (
    <ul className={'my-4'} style={{listStyle: "none", flexGrow: 2}}>
        {React.Children.map(props.children,
            (value, index) => {
                return (
                    <li key={index}>
                        {value}
                    </li>)
            })
        }
    </ul>
)

function InterestLink({children, title, authors, link}) {
    return (
        <div>
            <div style={{lineHeight: "0.8"}}>
                <a className={"interest-link"} style={{fontSize: "small"}} href={link}>{title}</a>
            </div>
            <p className="text-muted" style={{fontSize: "x-small", textAlign: "right"}}>{authors.join(', ')}</p>
        </div>
    )
}

export default function Interests() {

    return (
        <Container as={"section"} id="interests" className={"section-title"}>
            <h3 style={{textAlign: `center`}}>Interests</h3>

            <div className="separator pt-3">
                {/*<p>Here I provide with a bit of context of my current interests</p>*/}
                <div className={"card-deck my-5"}>
                    <Interest>
                        <InterestBody title={'Lottery Ticket'} img={lottery}>
                            <p>The lottery Ticket Hypothesis conjectures that every random initialized network
                                contains a subnetwork that is in charge of solving the problem.
                                Such subnetwork can be found using traditional pruning techniques.
                            </p>

                            <p>What I find interesting is how this subnetwork can match (and even surpass) the
                                performance of the whole network if retrained, but only when reinitialized
                                to the same original values of the whole network. When randomly reinitialized, it
                                won’t work. The conclusion is that initialization is the key (hence the name Winning
                                Lottery Ticket or LT).
                            </p>

                            <p>I find this phenomenon most interesting, as it shows that overparametrization is only
                                required during initialization. This opens up the possibility to do massive savings (on
                                parameters), if we could find the way to train this subnetwork from scratch.
                            </p>
                        </InterestBody>
                        <InterestLinkSection>
                            <InterestLink
                                title='The Lottery Ticket Hypothesis: Finding Sparse, Trainable Neural Networks'
                                authors={["Jonathan Frankle", "Michael Carbin"]}
                                link={"https://arxiv.org/abs/1803.03635"}/>
                            <InterestLink title='Deconstructing Lottery Tickets: Zeros, Signs, and the Supermask'
                                          authors={["Hattie Zhou", "Janice Lan", "Rosanne Liu", "Jason Yosinski"]}
                                          link={"https://arxiv.org/abs/1905.01067"}/>
                            <InterestLink title="Rigging the Lottery: Making All Tickets Winners"
                                          authors={["Utku Evci", "Trevor Gale", "Jacob Menick", "Pablo Samuel Castro", "Erich Elsen"]}
                                          link={"https://arxiv.org/abs/1911.11134"}/>
                        </InterestLinkSection>
                    </Interest>
                    <Interest>

                        <InterestBody title={"NAS and Constructive Networks"} img={constructive}>
                            <p>
                                Neural Network Search (NAS) is a technique for automating the design of Neural Networks.
                                This means avoiding the need for choosing from within a plethora of architectural
                                hyperparameters
                                (e.g. number and width of layers, connectivity, residuals or dense connections, etc).
                                Instead of using reinforcement learning or Genetic Algorithms, I advocate for something
                                less stochastic: constructive algorithms.
                            </p>
                            <p>
                                I envision something like Online-SVMs: you start from scratch, and keep adding supports
                                (automatically), until reaching a certain level of complexity, that is a function of the
                                regularization term. For Deep Learning, this implies adding units (correctly positioned)
                                until convergence is reached (contrary to pruning). At first, this problem seems like a
                                combinatorial nightmare, yet very stimulating as an end-goal.

                            </p>

                        </InterestBody>
                        <InterestLinkSection>
                            <InterestLink
                                title='A Constructive Approach for One-Shot Training of Neural Networks Using
                                Hypercube-Based Topological Coverings'
                                authors={["W. Brent Daniel", "Enoch Yeung"]}
                                link={"https://arxiv.org/abs/1901.02878"}/>
                        </InterestLinkSection>
                    </Interest>

                    <div className="w-100 d-none d-sm-block d-md-none"></div>
                    <div className="w-100 d-none d-md-block d-lg-none"></div>
                    <div className="w-100 d-none d-sm-block d-md-none"></div>
                    <div className="w-100 d-none d-lg-block d-xl-none"></div>
                    <div className="w-100 d-none d-xl-block"></div>
                    <Interest>

                        <InterestBody title={"Minimum Width Networks"} img={minimumwidth}>
                            <p>
                                Minimum width Networks are Networks whose layers have the least amount of units needed
                                to solve a problem. They are a stepping stone both in NAS and Lottery Ticket.
                                However, choosing the numbers of
                                units per layer remains an open problem in Deep Learning, despite the fact that some
                                guidelines exist in the form of -for example- EfficientNet or SimpNet. Ultimately,
                                choosing the number of units remains to this day an empirical finding and depends on
                                test error.

                            </p>
                            <p>
                                My interest is in finding a characterization of the capacity of layers (hopefully
                                extensible to the entire network), that match the complexity of the dataset (perhaps by
                                some
                                geometrical measure). To do so, I first need to answer the question of why is it so
                                difficult to train thin neural networks? In light of the LT hypothesis, we know that
                                thinner networks should work.
                            </p>

                        </InterestBody>
                        <InterestLinkSection>
                            <InterestLink
                                title='Superseding Model Scaling by Penalizing Dead Units and Points with Separation Constraints'
                                authors={['Carles Riera', 'Camilo Rey-Torres', 'Eloi Puertas', 'Oriol Pujol']}
                                link={"https://openreview.net/forum?id=B1eX_a4twH"}/>
                            <InterestLink title='Dying ReLU and Initialization: Theory and Numerical Examples'
                                          authors={["Lu Lu", "Yeonjong Shin", "Yanhui Su", "George Em Karniadakis"]}
                                          link={"https://arxiv.org/abs/1903.06733"}/>
                            <InterestLink title="Capacity allocation through neural network layers"
                                          authors={["Jonathan Donier"]}
                                          link={"https://arxiv.org/abs/1902.08572"}/>
                        </InterestLinkSection>
                    </Interest>

                    <Interest>

                        <InterestBody title={"Zero Initialization"} img={zeroinit}>
                            <p>
                                In order to develop a constructive algorithm for NAS, it is desireable to set weights
                                initially to zero. However, this is not possible in currently used Deep Learning
                                algorithms.
                            </p>
                            <p>
                                I’m under the impression that random initializations places an <i>inductive
                                bias</i> (particularly with the Lottery Ticket Hypothesis in sight) that is
                                poorly justified. Why do we choose one random distribution over another
                                (beyond exploding/vanishing gradient arguments)?
                            </p>
                            <p>
                                Instead, I advocate for Zero initialization: it’s clean, and theoretically sounder.
                                Hopefully, I can end --once and for all-- the debate over which initialization scheme is
                                superior.
                            </p>

                        </InterestBody>
                        <InterestLinkSection>
                            <InterestLink
                                title='Superseding Model Scaling by Penalizing Dead Units and Points with Separation Constraints'
                                authors={['Carles Riera', 'Camilo Rey-Torres', 'Eloi Puertas', 'Oriol Pujol']}
                                link={"https://openreview.net/forum?id=B1eX_a4twH"}/>

                        </InterestLinkSection>
                    </Interest>
                </div>
            </div>
        </Container>
)
}


